let scrollService = {
  scrollToTop() {
    // document.documentElement.scrollTop = 0;
  },
  getScrollTop(id) {
    let obj = document.getElementById(id);
    return obj.scrollTop;
  },
  addScrollListener(id, fun) {
    let obj = document.getElementById(id);
    obj.addEventListener('scroll', fun);
  },
  removeScrollListener(id, fun) {
    let obj = document.getElementById(id);
    obj.removeEventListener('scroll', fun);
  },
  isReachTop(id) {
    let obj = document.getElementById(id);
    return obj.scrollTop === 0;
  },
  isReachBottom(id) {
    let obj = document.getElementById(id);
    return Math.ceil(obj.scrollTop) + obj.offsetHeight >= obj.scrollHeight;
  },
  isNearBottom(id) {
    let obj = document.getElementById(id);
    return Math.ceil(obj.scrollTop) + obj.offsetHeight * 11 / 10 >= obj.scrollHeight;
  }
}

export default scrollService;



// WEBPACK FOOTER //
// ./src/services/scrollService.js